import { render, staticRenderFns } from "./PickHero.vue?vue&type=template&id=10cfdce0&"
import script from "./PickHero.vue?vue&type=script&lang=js&"
export * from "./PickHero.vue?vue&type=script&lang=js&"
import style0 from "./PickHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports